import { registerRoute, setNotFound, setOutlet, initRouter, navigate, currentPath } from './lib/router.js';
import { ensureSession, currentUser } from './lib/auth.js';
import { renderLogin } from './pages/login.js';
import {
  renderStudentDashboard, renderStudentWeek, renderStudentWeeks,
  renderStudentNotes, renderStudentWeekReport, renderStudentMyNotes,
} from './pages/student.js';
import {
  renderCoachDashboard, renderCoachWeeks, renderCoachWeekEditor,
  renderCoachReport, renderCoachSubjects, renderCoachNotes,
  renderCoachStudentNotes, renderCoachSources, renderCoachReports,
} from './pages/coach.js';
import { renderCountdown } from './pages/countdown.js';
import { h, mount } from './lib/dom.js';

const outlet = document.getElementById('app');
setOutlet(outlet);

// Auth guards
function requireAuth(handler, role = null) {
  return async (ctx) => {
    await ensureSession();
    const user = currentUser();
    if (!user) return navigate('/login', { replace: true });
    if (role && user.role !== role) {
      return navigate(user.role === 'coach' ? '/coach' : '/student', { replace: true });
    }
    await handler(ctx);
  };
}


// Public
registerRoute('/login', async (ctx) => {
  await ensureSession();
  if (currentUser()) return navigate(currentUser().role === 'coach' ? '/coach' : '/student', { replace: true });
  renderLogin(ctx);
});

// Root → redirect based on role
registerRoute('/', async () => {
  await ensureSession();
  const user = currentUser();
  navigate(user ? (user.role === 'coach' ? '/coach' : '/student') : '/login', { replace: true });
});

// Student
registerRoute('/student',                     requireAuth(renderStudentDashboard, 'student'));
registerRoute('/student/week',                requireAuth(renderStudentWeek, 'student'));
registerRoute('/student/weeks',               requireAuth(renderStudentWeeks, 'student'));
registerRoute('/student/weeks/:id',           requireAuth(renderStudentWeek, 'student'));
registerRoute('/student/weeks/:id/report',    requireAuth(renderStudentWeekReport, 'student'));
registerRoute('/student/notes',               requireAuth(renderStudentNotes, 'student'));
registerRoute('/student/my-notes',            requireAuth(renderStudentMyNotes, 'student'));

// Coach
registerRoute('/coach',                       requireAuth(renderCoachDashboard, 'coach'));
registerRoute('/coach/weeks',                 requireAuth(renderCoachWeeks, 'coach'));
registerRoute('/coach/weeks/:id',             requireAuth(renderCoachWeekEditor, 'coach'));
registerRoute('/coach/weeks/:id/report',      requireAuth(renderCoachReport, 'coach'));
registerRoute('/coach/subjects',              requireAuth(renderCoachSubjects, 'coach'));
registerRoute('/coach/sources',               requireAuth(renderCoachSources, 'coach'));
registerRoute('/coach/reports',               requireAuth(renderCoachReports, 'coach'));
registerRoute('/coach/notes',                 requireAuth(renderCoachNotes, 'coach'));
registerRoute('/coach/student-notes',         requireAuth(renderCoachStudentNotes, 'coach'));

// Shared
registerRoute('/countdown',                   requireAuth(renderCountdown));

setNotFound(async ({ outlet }) => {
  mount(outlet, h('div', { class: 'login-shell' },
    h('div', { class: 'login-card' },
      h('h2', {}, 'Sayfa bulunamadı'),
      h('p', { class: 'muted', style: { marginTop: 'var(--sp-2)' } }, currentPath()),
      h('a', { class: 'btn btn-primary', href: '#/', style: { marginTop: 'var(--sp-4)' } }, 'Ana sayfaya dön'),
    ),
  ));
});

initRouter();
